<template>
    <div style="cursor : pointer;">
        <div class="payType" :style="{border:(selected == true?'#ed6c00 solid 2px':'#eeeeee solid 2px')}">
            <span style="width:150px;font-size:16px;">{{label}}</span>
            <div><span style="width:150px;font-size:16px;">余额(</span><span style="font-size:16px;color:#ed6c00">{{teuAccount}}</span><span style="width:150px;font-size:16px;">TEU COIN)</span></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TeuAccount",
        props: {
            label: String,
            imgWidth: {
                default:"30px",
            },
            imagePath:{
                default:"",
            },
            selected: {
                default: false,
            },
            teuAccount: {
                default: 0,
            }
        },
        data: function () {
            return {
                labelValue: '66',
            };
        }
    }
</script>

<style lang="scss" scoped>
    .payType{
        display: flex;
        flex-direction: column;
        align-items: left;
        border: #ed6c00 solid 1px;
        padding:10px;
        span{
            margin-left: 5px;
        }
        // img{
        //     width:25px;
        // }
    }
    
</style>